import React from 'react';
import './contact.scss';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../common/Breadcrumb';

function Contact() {
  const { t } = useTranslation();

  const contactCards = [
    {
      role: t('contact.directorRole'),
      name: 'Usman',
      phone: '+62 811743349',
      email: 'usman@pelnasmsp.com',
    },
    {
      role: t('contact.operationsManagerRole'),
      name: 'Vincent Tay',
      phone: '+62 8118433498',
      email: 'vincent.tay@pelnasmsp.com',
    },
  ];

  return (
    <div className='contact-container'>
      <div className='main-content-container'>
        <Breadcrumb />

        <section className='contact-section'>
          <h2 className='section-title'>{t('contact.title')}</h2>

          {/* Google Maps Embed */}
          <div className='map-container'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.783!2d103.664547!3d-1.514033!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e258de275346043%3A0x5ede5ec90c51caa!2sPT.%20Pelayaran%20Nasional%20Mitra%20Samudra%20Perkasa!5e0!3m2!1sen!2sid!4v1704384000000!5m2!1sen!2sid'
              width='100%'
              height='400'
              style={{ border: 0 }}
              allowFullScreen
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
              title='Office Location'
            ></iframe>
          </div>

          {/* Address Info */}
          <div className='address-info'>
            <div className='info-item'>
              <h4>{t('contact.addressLabel')}</h4>
              <p>FMP8+9JM, Talang Duku, Taman Rajo, Muaro Jambi Regency Jambi 36382, Indonesia</p>
            </div>
            <div className='info-item'>
              <h4>{t('contact.phoneLabel')}</h4>
              <p>+62 741 7050089</p>
            </div>
          </div>
        </section>

        {/* Contact Cards */}
        <section className='contact-cards-section'>
          <h2 className='section-title'>{t('contact.teamTitle')}</h2>
          <div className='contact-cards-grid'>
            {contactCards.map((contact, index) => (
              <div className='contact-card' key={index}>
                <div className='contact-card-header'>
                  <h3 className='contact-name'>{contact.name}</h3>
                  <p className='contact-role'>{contact.role}</p>
                </div>
                <div className='contact-card-body'>
                  <div className='contact-detail'>
                    <span className='detail-label'>{t('contact.phoneLabel')}</span>
                    <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className='detail-value'>
                      {contact.phone}
                    </a>
                  </div>
                  <div className='contact-detail'>
                    <span className='detail-label'>{t('contact.emailLabel')}</span>
                    <a href={`mailto:${contact.email}`} className='detail-value email-link'>
                      {contact.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Contact;
